import * as React from 'react';
import { CreateSurveyProps } from '../common/CreateSurveyProps';
import getLangTranslation from '../common/lang-trans';

import TopNav from '../components/EditSurvey/TopNav';
import Start from "../components/EditSurvey/Start";
import Endnote from "../components/EditSurvey/Endnote";
import AddQuestion from "../components/EditSurvey/AddQuestion";
import Preview from "../components/EditSurvey/Preview";
import Publish from "../components/EditSurvey/Publish";
import Summary from "../components/EditSurvey/Summary";
import { Link } from 'react-router-dom';
import Group from '../components/EditSurvey/Group';
import { SurveyEditSteps } from '../common/constants';
import Header from '../components/header';

class AddEditSurvey extends React.PureComponent<CreateSurveyProps> {

    // This method is called when the component is first added to the document
    public componentDidMount() {
        const surveyId = this.props.match.params.surveyId || '';
        const isNew = this.props.match.params.isNew || 0;

        this.props.RequestSurvey(surveyId, isNew === '1', false);
    }

    public render() {

        const heading = this.props.survey.name || this.props.survey.title || this.props.survey.titleEn || '';

        return (
            <React.Fragment>
                <Header props={this.props}></Header>

                <TopNav step={this.props.step}
                        moveNextStep={ this.props.MoveNextStep }></TopNav>
                <div className="main-row">
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <h1 className="mb-4">{heading}</h1>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <div className="d-flex flex-row-reverse">
                                {
                                    this.props.isSurveyDirty
                                    ? <button className="btn btn-warning" disabled>Campaign List</button>
                                    : <Link className="btn btn-warning" to={`/search`}>Campaign List</Link>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row g-3">
                        {this.renderStepComponent()}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    private renderStepComponent() {
        const langTransEN = getLangTranslation('en');
        const langTransFR = getLangTranslation('fr');

        if (this.props.survey) {
            switch (this.props.step) {
                case SurveyEditSteps.UnableToLoad:
                    return (<><p>{ langTransEN.UnableToLoading }</p><p>{ langTransFR.UnableToLoading }</p></>);
                case SurveyEditSteps.Loading:
                    return (<><p>{ langTransEN.LoadingPleaseWait }</p><p>{ langTransFR.LoadingPleaseWait }</p></>);
                case SurveyEditSteps.Start:
                    return (<Start></Start>);
                case SurveyEditSteps.Group:
                    return (<Group></Group>);
                case SurveyEditSteps.Question:
                    return (<AddQuestion></AddQuestion>);
                case SurveyEditSteps.Summary:
                    return (<Summary></Summary>);
                case SurveyEditSteps.Endnote:
                    return (<Endnote></Endnote>);
                case SurveyEditSteps.Preview:
                    return (<Preview></Preview>);
                case SurveyEditSteps.Publish:
                    return (<Publish></Publish>);
            }
        } else {
            return (
                <p>{ langTransEN.UnableToLoading } / { langTransFR.UnableToLoading }</p>
            );
        }
    }
}

export default AddEditSurvey;
